export const types = {
  SORT_RECONCILIATIONS: 'SORT_RECONCILIATIONS',
  CLEAR_RECONCILIATION_SORT: 'CLEAR_RECONCILIATION_SORT',
};
